import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'icon-chevron-down',
  templateUrl: './chevron-down.component.svg',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChevronDownComponent {}
